export const getDaoData = () => ({
  name: "Dão",
  country: "Portugal",
  description: "Le Dão est une région montagneuse du centre du Portugal, réputée pour ses rouges élégants et ses blancs minéraux, issus de cépages autochtones.",
  type: "region",
  subregions: [
    { name: "Serra da Estrela", area: "5,000 ha", percentage: "25%", description: "Vins d'altitude, grande fraîcheur" },
    { name: "Silgueiros", area: "3,000 ha", percentage: "15%", description: "Vins élégants" },
    { name: "Castendo", area: "4,000 ha", percentage: "20%", description: "Vins puissants" },
    { name: "Besteiros", area: "2,000 ha", percentage: "10%", description: "Vins fruités" },
    { name: "Alva", area: "2,000 ha", percentage: "10%", description: "Vins blancs minéraux" },
    { name: "Terras de Azurara", area: "2,000 ha", percentage: "10%", description: "Vins de terroir" },
    { name: "Terras de Senhorim", area: "2,000 ha", percentage: "10%", description: "Vins équilibrés" }
  ],
  mapAreas: [
    { region: "Serra da Estrela", x: 47, y: 42, color: "#4B164C", size: 5 },
    { region: "Silgueiros", x: 49, y: 44, color: "#6d2c7a", size: 3 },
    { region: "Castendo", x: 51, y: 46, color: "#8a4a8a", size: 4 },
    { region: "Besteiros", x: 53, y: 48, color: "#a768a6", size: 2 },
    { region: "Alva", x: 55, y: 50, color: "#c486c4", size: 2 },
    { region: "Terras de Azurara", x: 57, y: 52, color: "#e2a4e2", size: 2 },
    { region: "Terras de Senhorim", x: 59, y: 54, color: "#f0c2f0", size: 2 }
  ],
  statistics: {
    totalArea: "20,000 ha",
    production: "500,000 hl",
    wineries: "80+ quintas",
    appellations: "7 sous-régions",
    exportPercentage: "20%"
  },
  characteristics: {
    climate: "Climat continental, hivers froids, étés chauds",
    soil: "Sols granitiques, sables, argiles",
    viticulture: "Vignes en altitude (400-700m), vendanges manuelles"
  },
  wineStyles: {
    red: "Rouges élégants, tanniques, grande capacité de garde (Touriga Nacional, Jaen, Alfrocheiro)",
    white: "Blancs minéraux, frais, à base d'Encruzado"
  },
  history: "Le Dão est l'une des plus anciennes régions délimitées du Portugal (1908). Les vins du Dão sont réputés pour leur élégance et leur potentiel de garde.",
  foodPairing: "Agneau rôti, fromages de montagne, plats mijotés, cuisine du centre du Portugal"
}); 